module.exports = __webpack_public_path__ + "img/logo-examview-blue.698b0b88.svg";